<template>
  <modal :show="show" @close="close">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Delete Adjustment #{{ adjustmentId }}?</modal-header>
    </div>
    Are you sure you want to delete this adjustment?
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'

import {invoiceMixin} from '@/mixins/invoiceMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_delete_adjustment',
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  mixins: [invoiceMixin, modalMixin, notificationMixin],
  props: {
    show: Boolean,
    field: String,
    adjustmentId: [Number, String]
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.deleteSingleAdjustment(this.adjustmentId).then(() => {
        this.getSingleInvoice(this.$route.params.id).then(() => {
          this.addNotification('success', `'Adjustment #${this.adjustmentId}' has been deleted.`)
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/invoices/modal-delete-adjustment.vue